import React from 'react'
import { isBrowser } from 'react-device-detect'
import ErrorLayout from 'core/templates/ErrorLayout'
import styled from 'styled-components'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Row, Col } from 'core/components/ui'
import img from 'assets/images'
import { font, greys } from 'assets/themes/theme-default'

const BKG = styled.div`
  position: absolute;
  background-image: ${isBrowser && `url('${img.errorBKG}')`};
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  width: 100%;
`
const RowContentWrapper = styled(Row)`
  position: absolute;
  height: 100%;
  width: 100%;
`
const Title = styled.h2`
  color: ${greys.drak1};
  text-transform: uppercase;
  font-weight: ${font.weight.black};
  font-size: ${font.size.lgxxl};
  margin: 65px 0 10px;
`
const SubTitle = styled.h4`
  color: ${props => props.theme.colors.color1.bg};
  font-weight: ${font.weight.base};
`

const ErrorPage = () => (
  <ErrorLayout data-test="component-error-page" showSider={false}>
    <BKG>
      <RowContentWrapper type="flex" align="middle">
        <Col span={12} offset={4}>
          <Title data-test="error-page-title">
            <FormattedMessage id="error-title" />
          </Title>
          <SubTitle data-test="error-page-subtitle">
            <FormattedMessage id="error-subtitle" />
          </SubTitle>
        </Col>
      </RowContentWrapper>
    </BKG>
  </ErrorLayout>
)

ErrorPage.propTypes = {}

export default injectIntl(ErrorPage)
